module.exports = __webpack_public_path__ + "static/media/four.634633c5.jpeg";